<template>
  <div>
    <div v-for="item in items" :key="item.id" class="message mb-4">
      <GroupMemberItem
        :image-url="item.author.avatarUrl"
        :name="item.author.name"
        :participant-id="item.author.id"
        size="medium"
        class="mr-3"
      />
      <div class="content">
        <div class="author-and-date">
          <div class="author">
            {{ item.author.name }}
          </div>
          <div class="date">
            {{ formatDate(item.sent_at) }}
          </div>
        </div>
        <div class="comment">
          {{ item.content }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import GroupMemberItem from './GroupMemberItem'
export default {
  name: 'Messages',
  components: {
    GroupMemberItem
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {}
  },
  watch: {},
  created: function () {},
  methods: {
    formatDate(datetime) {
      return moment(datetime).fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
.message {
  display: flex;
  flex: 1;
}
.content {
  flex: 1;
}
.author-and-date {
  display: flex;
  @media (max-width: 480px) {
    flex-direction: column;
  }
}
.author {
  font-weight: 600;
  flex: 1;
}
.date {
  font-size: 0.875rem;
  color: #777;
  margin-bottom: 0.25rem;
}
</style>
